import { innerSearch } from 'api/Api';
import LoadingIndicator from 'app/components/LoadingIndicator';
import LoadingText from 'app/components/LoadingText';
import PayverseDirectHeader from 'app/components/PayverseDirectHeader';
import { usePaymentState } from 'payment_state/PaymentStateContext';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';

interface ReturnForm {
  resultStatus: string;
  resultMessage: string;
  resultCode: string;
  tid: string;
  orderId: string;
  mallReserved: string;
}

const DirectResultPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const searchParams = useLocation().search;
  const navigate = useNavigate();
  const { setPaymentState } = usePaymentState();
  const [tid, setTid] = useState<string>('');

  // InnerSearch 실행
  const transactResult = useMutation(() => innerSearch(tid), {
    onSuccess: data => {
      //Status 예외처리
      if (
        data.data.response.resultStatus === null ||
        data.data.response.resultStatus === undefined
      ) {
        navigate('/error');
        return;
      }
      if (
        data.data.response.resultStatus === 'PROCESSING' ||
        data.data.response.resultStatus === 'PENDING'
      ) {
        handlePolling(data.data.response, data.data.returnUrl);
        return;
      } else {
        createFormAndSubmit(data.data.response, data.data.returnUrl);
        return;
      }
    },
    onError: error => {
      navigate('/error');
    },
  });

  const transactPolling = useMutation(() => innerSearch(tid), {
    onSuccess: data => {
      const status = data.data.response.resultStatus;
      //Status 예외처리
      if (
        data.data.response.resultStatus === null ||
        data.data.response.resultStatus === undefined
      ) {
        navigate('/error');
        return;
      }
      if (!['PENDING', 'PROCESSING'].includes(status)) {
        createFormAndSubmit(data.data.response, data.data.returnUrl);
        return;
      }
    },
    onError: error => {
      navigate('/error');
    },
  });

  const handlePolling = (response, returnUrl) => {
    let polling = setInterval(() => {
      transactPolling.mutate();
    }, 2000);

    setTimeout(() => {
      createFormAndSubmit(response, returnUrl);
      clearInterval(polling);
    }, 10000);

    return () => {
      createFormAndSubmit(response, returnUrl);
      clearInterval(polling);
    };
  };

  useEffect(() => {
    const browserTypeJson = (lang: string) => {
      switch (lang) {
        case 'zh-TW':
          return 'cntr';
        case 'zh-CN':
          return 'cnsi';
        case 'en-US':
          return 'en';
        case 'ko':
          return 'ko';
        case 'ko-KR':
          return 'ko';
        case 'ja':
          return 'jp';
        default:
          return '';
      }
    };
    const userLanguage = navigator.language;
    const browserLanguage = browserTypeJson(userLanguage);
    if (browserLanguage !== '') {
      i18n.changeLanguage(browserLanguage);
      return;
    } else {
      i18n.changeLanguage('en');
    }
  }, []);

  useEffect(() => {
    const paramTid = new URLSearchParams(searchParams).get('tid');
    const paramFail = new URLSearchParams(searchParams).get('isFail');
    if (paramFail === 'Y') {
      if (paramTid) {
        setTid(paramTid);
        setPaymentState(prevState => ({ ...prevState, tid: paramTid }));
      }
    } else {
      if (!isMobile) {
        window.close();
      } else {
        if (paramTid) {
          setTid(paramTid);
          setPaymentState(prevState => ({ ...prevState, tid: paramTid }));
        }
      }
    }
  }, [searchParams]);

  useEffect(() => {
    if (tid) {
      transactResult.mutate();
    }
  }, [tid]);

  const createFormAndSubmit = (formData, returnUrl) => {
    const form = document.createElement('form');
    form.setAttribute('method', 'POST');
    form.setAttribute('action', `${returnUrl}`);
    form.style.display = 'none';

    Object.entries(formData).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', key);
      input.setAttribute('value', String(value));
      form.appendChild(input);
    });
    document.body.appendChild(form);

    form.submit();
  };

  return (
    <>
      <div className="payverse-wrap">
        <div className="payverse">
          <PayverseDirectHeader />
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              height: '70%',
            }}
          >
            <LoadingIndicator />
            <LoadingText />
          </div>
        </div>
      </div>
    </>
  );
};

export default DirectResultPage;
